import { render, staticRenderFns } from "./formAnamnese.vue?vue&type=template&id=03993e9b&scoped=true"
import script from "./formAnamnese.vue?vue&type=script&lang=js"
export * from "./formAnamnese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03993e9b",
  null
  
)

export default component.exports